import { useMemo } from 'react'
import { useRepoMeta } from '@/lib/query'

/**
 * Teams ARE the repo's `area/*` labels — derived live so new areas appear
 * without an app change. Empty until the label list loads (no fallback).
 */
export function useTeams(): string[] {
  const labels = useRepoMeta().data?.labels
  return useMemo(
    () =>
      (labels ?? [])
        .map((l) => l.name)
        .filter((name) => name.startsWith('area/'))
        .map((name) => name.slice('area/'.length))
        .sort((a, b) => a.localeCompare(b)),
    [labels],
  )
}
